import { render, staticRenderFns } from "./coefficient-and-adsorbate.vue?vue&type=template&id=339ad3b6&"
import script from "./coefficient-and-adsorbate.vue?vue&type=script&lang=js&"
export * from "./coefficient-and-adsorbate.vue?vue&type=script&lang=js&"
import style0 from "./coefficient-and-adsorbate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports